import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LOGIN_PATH, MAIN_PATH } from '../constant/Constant';
import { handleClose } from '../module/ErrorPopupModule';
import NullCheckUtil from '../util/NullCheckUtil';

const ErrorPopup = ({}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { open, message, goPage } = useSelector((state) => state.errorPopupState);

    const onClick = () => {
        dispatch(handleClose());

        console.log('ErrorPopup onClick');
        console.log(goPage);

        if (NullCheckUtil.isNotEmpty(goPage)) {
            navigate(goPage);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            onClick();
        }
    };

    return open ? (
        <>
            <div className='toast error fade show'>
                <div className='toast-body'>
                    <div className='error-inner'>
                        <span className='ico-error'></span>
                        <div className='error-msg-tit'>요청하신 페이지에 오류가 발생하였습니다.</div>
                        <div className='error-detail'>
                            <div className='detail-tit'>사유</div>
                            <div className='detail-blue'>{message}</div>
                        </div>
                        <p className='txt-center'>
                            긴급한 시스템 점검으로 일시적으로 오류가 발생할 수 있습니다.
                            <br />
                            브라우저를 모두 닫은 후 새로 열어 다시 시도하세요.
                            <br />
                            구 버전의 브라우저나 IE 를 사용하시는 경우,
                            <br />
                            최신 버전의 브라우저(예:Chrome)를 사용해 주시기 바랍니다.
                            <br />
                        </p>
                    </div>
                </div>
                <div className='toast-foot btn-wrap'>
                    <button
                        autoFocus
                        type='button'
                        className='btn btn-popup positive'
                        onClick={() => onClick()}
                        onKeyDown={onKeyDown}
                    >
                        확인
                    </button>
                </div>
            </div>
            <div className='toast-back fade show'></div>
        </>
    ) : (
        <></>
    );
};

export default ErrorPopup;
